import React, { useState } from "react";
import { motion } from "framer-motion";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { bentoniteMinerals, industrialMinerals } from "../Data";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactSection = () => {
  const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  bentoniteMineral: "",
  industrialMineral: "",
  message: "",
});

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.firstName)
    return toast.error("Enter first name");

  if (!formData.lastName)
    return toast.error("Enter last name");

  if (!formData.email)
    return toast.error("Enter email");

  if (!formData.phone)
    return toast.error("Enter phone number");

  if (!formData.message)
    return toast.error("Enter message");

  setLoading(true);

  try {
    const template = `
<div style="
margin:0;
padding:50px 0;
background:#F6F4F0;
font-family:Georgia,'Times New Roman',serif;
">

<table width="100%" cellpadding="0" cellspacing="0">
<tr>
<td align="center">

<table
width="720"
cellpadding="0"
cellspacing="0"
style="
background:#ffffff;
border-radius:24px;
overflow:hidden;
box-shadow:0 15px 50px rgba(0,0,0,0.08);
"
>

<!-- TOP ACCENT -->

<tr>
<td
style="
height:8px;
background:#88664D;
"
></td>
</tr>

<!-- HEADER -->

<tr>
<td
style="
padding:55px 50px;
text-align:center;
background:#ffffff;
"
>

<!-- LOGO -->

<!--
<img
src='https://your-domain.com/logo.png'
alt='Iris Impulse India Pvt. Ltd. Logo'
style='max-width:220px;margin-bottom:25px;'
/>
-->

<div
style="
font-size:13px;
letter-spacing:4px;
text-transform:uppercase;
color:#88664D;
margin-bottom:15px;
"
>
Global Leader in Bentonite & Industrial Minerals Since 1991
</div>

<h1
style="
margin:0;
font-size:34px;
font-weight:500;
color:#1E1E1E;
line-height:1.3;
"
>
New Website Enquiry
</h1>

<p
style="
margin-top:18px;
font-size:15px;
color:#777;
line-height:1.8;
"
>
A new enquiry has been submitted through the IRIS Impulse website.
</p>

</td>
</tr>

<!-- CUSTOMER DETAILS -->

<tr>
<td style="padding:0 50px 50px;">

<h2
style="
font-size:22px;
font-weight:500;
color:#88664D;
margin-bottom:20px;
"
>
Customer Information
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #E8E3DD;
border-radius:16px;
overflow:hidden;
"
>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #E8E3DD;">
<span style="color:#999;">Full Name</span><br/>
<strong>
${formData.firstName} ${formData.lastName}
</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #E8E3DD;">
<span style="color:#999;">Email Address</span><br/>
<strong>
${formData.email}
</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;">
<span style="color:#999;">Phone Number</span><br/>
<strong>
+${formData.phone}
</strong>
</td>
</tr>

</table>

<!-- PRODUCT INTEREST -->

<h2
style="
font-size:22px;
font-weight:500;
color:#88664D;
margin:35px 0 20px;
"
>
Product Interest
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #E8E3DD;
border-radius:16px;
overflow:hidden;
"
>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #E8E3DD;">
<span style="color:#999;">
Bentonite Mineral
</span><br/>
<strong>
${formData.bentoniteMineral || "Not Selected"}
</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;">
<span style="color:#999;">
Industrial Mineral
</span><br/>
<strong>
${formData.industrialMineral || "Not Selected"}
</strong>
</td>
</tr>

</table>

<!-- MESSAGE -->

<h2
style="
font-size:22px;
font-weight:500;
color:#88664D;
margin:35px 0 20px;
"
>
Message
</h2>

<div
style="
background:#FAFAFA;
border:1px solid #E8E3DD;
border-radius:16px;
padding:24px;
line-height:1.9;
color:#444;
"
>
${formData.message}
</div>

</td>
</tr>

<!-- FOOTER -->

<tr>
<td
style="
background:#88664D;
padding:35px;
text-align:center;
"
>

<div
style="
font-size:20px;
font-weight:600;
color:#ffffff;
margin-bottom:10px;
"
>
IRIS Impulse India Pvt. Ltd.
</div>

<p
style="
margin:0;
color:#EFE7E1;
font-size:13px;
line-height:1.8;
"
>
Gandhidham • Kutch • Gujarat 
</p>

</td>
</tr>

</table>

</td>
</tr>
</table>

</div>
`;

    const data = new FormData();

    data.append(
      "title",
      "IRIS Website Enquiry"
    );

    data.append(
      "to_email",
      "rajan@irisimpulse.com"
    );

    data.append(
      "cc",
      "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

    data.append(
      "subject",
      "New Enquiry from Website"
    );

    data.append(
      "template",
      template
    );

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    toast.success(
      "Enquiry submitted successfully."
    );

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      bentoniteMineral: "",
      industrialMineral: "",
      message: "",
    });

  } catch (error) {

    toast.error(
      "Something went wrong."
    );

  } finally {

    setLoading(false);

  }
};

  const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 }
  }
};   
return (
    <section className="new-contact-section">
      <ToastContainer
  position="top-right"
  autoClose={3000}
/>
      <div className="container">

        <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      CONTACT US
    </motion.h2>

    {/* TEXT */}
    <motion.div
      initial="hidden"
      whileInView="visible"
      variants={container}
      viewport={{ once: true }}
    >
      <motion.p className="section-text" variants={fadeUp}>
        Thank you for your interest in <b className="bold">Iris Impulse India Pvt. Ltd.</b><br />
        Prefer to talk? Call us on: (+91) 9638482211 or mail our 
        <strong> Marketing & Business Development Head  Mr. Rajan Gemawat at : rajan@irisimpulse.com</strong>
      </motion.p>

      <motion.p className="section-text" variants={fadeUp}>
        <b className="bold">Corporate Office :</b><br />
     “IRIS HOUSE”, Plot-39, Ward-7/C, Gurukul Road, Gandhidham, Kutch, Gujarat, India – 370201
      </motion.p>

      <motion.p className="section-text" variants={fadeUp}>
        <b className="bold">Plant Address:</b><br />
      Ashirwad Minechem, Plot-199/200 & 203, GIDC Durgapur, Mandvi-Kutch, Gujarat, India – 370465
      </motion.p>
    </motion.div>
        {/* FORM */}
       <form
  className="new-contact-form"
  onSubmit={handleSubmit}
>

          <div className="new-contact-row">
            <input
  type="text"
  name="firstName"
  value={formData.firstName}
  onChange={handleChange}
  placeholder="First Name *"
  className="new-input"
/>

         <input
  type="text"
  name="lastName"
  value={formData.lastName}
  onChange={handleChange}
  placeholder="Last Name *"
  className="new-input"
/>
        <input
  type="email"
  name="email"
  value={formData.email}
  onChange={handleChange}
  placeholder="Email *"
  className="new-input"
/>
          </div>

          <div className="new-contact-row">
            <PhoneInput
  country={"in"}
  value={formData.phone}
  onChange={(value) =>
    setFormData((prev) => ({
      ...prev,
      phone: value,
    }))
  }
  inputClass="new-phone-input"
  containerClass="new-phone-container"
  buttonClass="new-phone-flag"
/>
            {/* PHONE INPUT */}
           <select
  className="new-input"
  name="bentoniteMineral"
  value={formData.bentoniteMineral}
  onChange={handleChange}
>
  <option value="">
    Select Bentonite Mineral *
  </option>

  {bentoniteMinerals.map((item, index) => (
    <option
      key={index}
      value={item.title}
    >
      {item.title}
    </option>
  ))}
</select>

           <select
  className="new-input"
  name="industrialMineral"
  value={formData.industrialMineral}
  onChange={handleChange}
>
  <option value="">
    Select Industrial Mineral *
  </option>

  {industrialMinerals.map((item, index) => (
    <option
      key={index}
      value={item.title}
    >
      {item.title}
    </option>
  ))}
</select>
          </div>

          <div className="new-contact-row">
           <input
  type="text"
  name="message"
  value={formData.message}
  onChange={handleChange}
  placeholder="Message *"
  className="new-input full"
/>
          </div>

        <button
  type="submit"
  className="outline-btn"
  disabled={loading}
>
  {loading ? "SENDING..." : "SUBMIT"}
</button>

        </form>
      </div>
    </section>
  );
};

export default ContactSection;